import React from 'react';
import { motion } from 'framer-motion';
import { GlobeIcon, PhoneIcon, ShieldCheckIcon, LayoutDashboardIcon, ArrowRightIcon } from 'lucide-react';
export function HowItWorks({
  onOpenQuote
}: {
  onOpenQuote?: () => void;
}) {
  const steps = [{
    title: 'Bill Auditors',
    eyebrow: 'TELECOM EXPENSE SPECIALISTS',
    desc: 'We analyze every line item on your telecom bills to uncover hidden fees, billing errors, and overcharges that cost your business thousands each year.',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=800&h=600&fit=crop'
  }, {
    title: 'Rate Negotiators',
    eyebrow: 'EXCLUSIVE PROVIDER ACCESS',
    desc: "We leverage relationships with every major carrier to negotiate rates your business can't get on its own. We guarantee the most competitive pricing available.",
    image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&h=600&fit=crop'
  }, {
    title: 'Cost Optimizers',
    eyebrow: 'ONGOING EXPENSE REDUCTION',
    desc: "We don't just find savings once — we continuously monitor your telecom spend, flag cost creep, and recommend adjustments to keep your expenses as low as possible.",
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop'
  }];
  return <section className="py-24 bg-white overflow-hidden" data-id="element-219">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-220">
        {/* Section Title */}
        <div className="text-center mb-16" data-id="element-221">
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#011B33]" data-id="element-222">
            How it Works
          </h2>
          <div className="w-20 h-1.5 bg-[#22A39F] mx-auto mt-6 rounded-full" data-id="element-223"></div>
        </div>

        {/* Top Row: 3 Large Vertical Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20" data-id="element-224">
          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="relative rounded-[2.5rem] bg-[#F5F7F8] border border-slate-100 flex flex-col overflow-hidden group hover:border-[#22A39F]/30 transition-all shadow-sm hover:shadow-xl" data-id="element-225">
              <div className="h-56 overflow-hidden" data-id="element-226">
                <img src={step.image} alt={step.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-227" />
              </div>
              <div className="p-10 flex flex-col items-start" data-id="element-228">
                <div className="text-[10px] font-bold text-[#22A39F] uppercase tracking-[0.2em] mb-4" data-id="element-229">
                  {step.eyebrow}
                </div>
                <h3 className="text-2xl font-bold text-[#011B33] mb-4" data-id="element-230">
                  {step.title}
                </h3>
                <p className="text-slate-500 leading-relaxed" data-id="element-231">{step.desc}</p>
              </div>
            </motion.div>)}
        </div>

        {/* Middle Row: Icon Strip */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:flex lg:flex-row lg:justify-center items-center gap-y-10 gap-x-12 md:gap-24 mb-24 py-12 border-y border-slate-100" data-id="element-232">
          {[{
          icon: GlobeIcon,
          label: 'Business Internet'
        }, {
          icon: PhoneIcon,
          label: 'Business Phones'
        }, {
          icon: ShieldCheckIcon,
          label: 'Security'
        }, {
          icon: LayoutDashboardIcon,
          label: 'Website/CRM'
        }].map((item, i) => <div key={i} className="flex items-center gap-4 group justify-center sm:justify-start lg:justify-center px-4" data-id="element-233">
              <div className="w-12 h-12 rounded-xl bg-[#011B33] flex items-center justify-center text-[#22A39F] group-hover:scale-110 transition-transform" data-id="element-234">
                <item.icon className="w-6 h-6" data-id="element-235" />
              </div>
              <span className="text-sm font-bold text-[#011B33] uppercase tracking-widest" data-id="element-236">
                {item.label}
              </span>
            </div>)}
        </div>

        {/* Final CTA */}
        <div className="flex justify-center" data-id="element-237">
          <button onClick={onOpenQuote} className="bg-[#22A39F] hover:bg-[#1d8a87] text-white px-12 py-5 rounded-2xl font-bold text-xl transition-all shadow-xl shadow-[#22A39F]/20 flex items-center gap-3 group" data-id="element-238">
            Get Started Now
            <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-239" />
          </button>
        </div>
      </div>
    </section>;
}